/* eslint-disable react-hooks/exhaustive-deps */
import Breadcrumcomponent from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDownFilter } from "components/InputsMex/inputs";
import Page from "components/Page";
import {
  ambienteAplicacion,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useUsuario from "hooks/useUsuario";
import { isArray } from "lodash";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useReducer, useState } from "react";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router";
import useParametrosPago from "redux/hooks/useParametrosPago";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import TARJETAS from "utils/constants/TARJETAS";
import { mappRutasEmision } from "utils/funciones";
import { capitalize } from "utils/string";
import Loading from "wrappers/Loading";
import OpcionesPago from "./componentes/OpcionesPago";
import { Hogar } from "./constantes/general";
import pasosBreadCrumbHogar from "./constantes/pasosBreadCrumb";
import "./styles.scss";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { URLS_PHP_8 } from "constants/urls_v2";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

const HogarDatosGenerales = ({
  history,
  addWarningToast,
  addSuccessToast,
  dataUsuario,
  ...props
}) => {
  useNavbarContext(Hogar.codProducto);

  const [showOpciones, setshowOpciones] = useState(false);
  const [showLogos, setShowLogos] = useState(false);
  const [cotizacion, setCotizacion] = useState(null);
  const [loading, setLoading] = useState(true);

  const [cobertura, setCobertura] = useState("");
  const [secciones, setSecciones] = useState([]);
  const { idCotizacion } = useParams();

  const [datosTarifacion, setDatosTarifacion] = useState(null);
  const [isRecalculando, setRecalcular] = useState(false);

  const [seleccionMeses, setseleccionMeses] = useState(false);

  const [pagoRealizado, setPagoRealizado] = useState(false);

  const [state, setState] = useReducer((a, b) => ({ ...a, ...b }), {
    meses: [],
    showmeses: false,
    formasPago: [],
    tarjetas: [{ label: "visa", value: "visa" }],
    loadingTarifacion: false,
    datosTarifacion: "",
    formaPago: "",
    plazo: "",
    dialogShow: false,
    dialogData: [],
  });

  const [resumen, setResumen] = useState({});

  const { fetchParametros, parametros, setCombos, ...stateParametrosPago } =
    useParametrosPago();
  const { isAgente } = useUsuario();
  const methods = useForm({ mode: "onChange" });
  const { getValues } = methods;

  useEffect(() => {
    if (!idCotizacion) {
      history.replace("/");
      history.push(Hogar.urls.datosPersonales);
    }
  }, [idCotizacion]);

  const tarifar = ({ idPlazo, formaPago, labelPlazo }) => {
    if (!formaPago) return;
    setRecalcular(true);

    const Data = {
      cotCodigo: idCotizacion,
      ambiente: ambienteAplicacion,
      formaPago,
      idPlazo,
      labelPlazo,
      codigoUsuario: "",
    };

    console.log(Data);

    ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.tarifacionCotizacion, Data)
      .then((res) => {
        if (res.transaccion) {
          setDatosTarifacion(res?.datosTarifacion);
        } else {
          addWarningToast(
            "Ocurrio un error Calculando, seleccione otro tipo de pago o refresque la página"
          );
        }
      })
      .catch((err) => {
        addWarningToast(
          "Ocurrio un error Calculando, seleccione otro tipo de pago o refresque la página"
        );
      })
      .finally(() => setRecalcular(false));
  };

  const init = async () => {
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
      },
    };

    const data = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.resumenCotizacion, DataResumen);

    console.log("RESUMEN: ", data);

    if (data?.transaccion) {
      setCotizacion(data?.cotConsulta);
      setResumen(data);
      const resumen = data?.cotConsulta;
      const totales = resumen?.totGenerales?.[0];

      setPagoRealizado(!!resumen?.pagoRealizado);
      //setPagoRealizado(true);
      setDatosTarifacion(totales);

      let paquete = resumen?.prodDatos?.find((item) => !!item.seleccionado);
      console.log(dataUsuario);
      if (isAgente) {
        paquete = resumen?.prodDatos[0];
      }

      fetchParametros(data?.prodCodigo, idCotizacion);

      let plan = paquete?.planes?.find((item) => !!item.seleccionado);
      if (isAgente) {
        plan = resumen?.prodDatos[0].plan;
      }
      tarifar({
        formaPago: totales?.formaPago || "contado",
        idPlazo: totales?.idPlazo || "1",
        labelPlazo: totales?.labelPlazo || "CONTADO",
      });
      setCobertura({ paquete, plan });

      setSecciones(data?.coberturas || []);
    }

    setLoading(false);
  };
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (parametros && datosTarifacion) {
      setCombos({
        formaPago: datosTarifacion?.formaPago,
        idPlazo: datosTarifacion?.idPlazo,
        setShowLogos,
        setshowOpciones,
        reset: methods.reset,
      });
    }
  }, [parametros, datosTarifacion]);

  const onSubmit = async (data) => {
    setLoading(true);
    let Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: "crearPoliza",
        prodCodigo: PRODUCTOS.HOGAR,
        cotCodigo: idCotizacion,
      },
    };

    if (isAgente) {
      Data = {
        datosCotizador: {
          ambiente: ambienteAplicacion,
          cotPasoCodigo: "crearPolizaAbierta",
          prodCodigo: resumen.prodCodigo,
          cotCodigo: idCotizacion,
        },
      };
    }
    setLoading(true);

    console.log("Data submit: ", Data);
    const res = await ApiKeyFetch.instance().post(URLS_PHP_8.emision.datosEmision, Data);
    console.log("RES: ", res);
    if (
      res?.transaccion &&
      res?.catalogo?.pasosRedireccionamiento &&
      isArray(res?.catalogo?.pasosRedireccionamiento) &&
      res?.catalogo?.idPoliza
    ) {
      const rutas = mappRutasEmision(res.catalogo.pasosRedireccionamiento);
      history.replace(rutas.resumen.goTo);
      history.push(rutas.resumen.goTo);
    }
    setLoading(false);
  };

  const onSubmitError = (errors) => {
    stateParametrosPago.error && addWarningToast(stateParametrosPago.error);
  };

  const handleRegresar = () => {
    if (isAgente) {
      history.push(`${Hogar.urls.individualFlexible2}/${idCotizacion}`);
    } else {
      history.push(`${Hogar.urls.coberturas}/${idCotizacion}`);
    }
  };

  const onChangeFormPago = (value) => {
    if (value.onChange === "recalcular") {
      tarifar({
        idPlazo: value.id,
        formaPago: value.tipo,
        labelPlazo: value.label,
      });
      setShowLogos(false);
      setseleccionMeses(false);
    } else {
      setShowLogos(true);
    }
    setshowOpciones(value?.mostrarSubopciones);
  };
  const onChangePlazo = (value) => {
    setseleccionMeses(true);
    const formaPago = getValues("formaPago");
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  const stripColors = ["#C0E7F7", "#F2B773", "#B598E3", "#9ADDD8"];

  const [showDialog, setShowDialog] = useState(false);
  const handleShow = () => {
    setShowDialog(true);
  };
  const handleClose = () => {
    setShowDialog(false);
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <Breadcrumcomponent {...pasosBreadCrumbHogar.breadCrumb} showPaths={true} />
          {!isAgente ? (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumbPasosCotizacion[3]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosCotizacion}
            />
          ) : (
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]
                .breadCrumbPasosCotizacionHogarFlex[4]}
              pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosHogarFlex}
            />
          )}
          <div className='row gap-3 m-2'>
            <div className='col-md-6'>
              <div className='border p-4'>
                <div className='col text-center m-2'>
                  <h3 className='font-mex'>
                    ¡Has elegido!
                    {/* <strong>{cobertura?.plan?.producto}</strong> */}
                  </h3>

                  <div className='row justify-content-center mt-3 mb-5'>
                    <div className='col-11 col-md-8 border-mex-ap text-center py-4'>
                      <div
                        className='text-center font-20px w-100'
                        style={{
                          backgroundColor: stripColors[(cobertura?.plan?.id ?? 1) - 1],
                          paddingBottom: "0.5rem",
                          paddingTop: "0.3rem",
                          margin: "0 0 0 0 ",
                          paddingLeft: "0",
                          paddingRight: "0",
                        }}>
                        <h4 className='font-mex text-mex mt-2'>
                          {cobertura?.plan?.producto}
                        </h4>
                      </div>
                      <h2 className='font-mex'>
                        $
                        {datosTarifacion?.primaNeta ||
                          cobertura?.plan?.precioFormato ||
                          ""}
                        {isAgente ? ` ${datosTarifacion?.monedaSimbolo || ""}` : " mxn"}
                      </h2>
                    </div>
                  </div>
                </div>

                {cotizacion?.breviario?.map?.(({ id, descripcion, lista = [] }) => (
                  <React.Fragment key={id}>
                    {lista.length > 0 && (
                      <p
                        className='cpointer font-20px'
                        style={{ color: "#ee8130" }}
                        onClick={() =>
                          setState({
                            dialogShow: true,
                            dialogData: lista,
                          })
                        }>
                        Ver {descripcion}
                      </p>
                    )}
                    {lista.length === 0 && (
                      <p className='font-source-sans-regular font-20px'>{descripcion}</p>
                    )}
                  </React.Fragment>
                ))}
                {isAgente && (
                  <div className='d-flex justify-content-center mb-3'>
                    <h3 className='link-coberturas font-26px' onClick={handleShow}>
                      Ver coberturas
                    </h3>

                    <Modal show={showDialog} onHide={handleClose}>
                      <Modal.Header closeButton>
                        <Modal.Title className='font-26px'>Coberturas</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {secciones?.map((val, index) => {
                          return (
                            <React.Fragment key={val.label}>
                              <div className='row my-2'>
                                <p className='col-9 my-0 py-0 font-20px font-source-sans-regular'>
                                  {capitalize(val.label)}
                                </p>
                                <p className='col-3 my-0 py-0 font-20px align-self-center font-source-sans-regular'>
                                  {typeof val.suma === "number" &&
                                    `${formatter.format(val.suma)}`}
                                  {typeof val?.suma === "string" && capitalize(val.suma)}
                                </p>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </Modal.Body>
                    </Modal>
                  </div>
                )}

                <FormProvider {...methods}>
                  <form>
                    <div className='row'>
                      <div className='col-xl-6'>
                        <SimpleContainer
                          name='formaPago'
                          label='Opción de pago'
                          helpText={
                            (stateParametrosPago.loading &&
                              "Cargando formas de pago...") ||
                            ((!parametros?.formasPago ||
                              parametros?.formasPago?.length === 0) &&
                              "No tiene formas de pago configuradas")
                          }>
                          <DropDownFilter
                            name='formaPago'
                            filter={false}
                            rules={{
                              required: "Este campo es obligatorio",
                            }}
                            options={parametros?.formasPago || []}
                            onChangeFn={onChangeFormPago}
                            loading={stateParametrosPago.loading}
                            disabled={pagoRealizado || isRecalculando}
                            loadingText={stateParametrosPago?.loading && "Cargando..."}
                          />
                        </SimpleContainer>
                      </div>

                      {showOpciones && (
                        <div className='col-xl-6'>
                          <SimpleContainer label='Elije cuántos meses' name='idPlazo'>
                            <DropDownFilter
                              name='idPlazo'
                              filter={false}
                              rules={{ required: "Obligatorio" }}
                              options={parametros.plazos}
                              onChangeFn={onChangePlazo}
                              disabled={pagoRealizado || isRecalculando}
                              loading={stateParametrosPago?.loading}
                            />
                          </SimpleContainer>
                        </div>
                      )}
                    </div>
                  </form>
                </FormProvider>

                {showLogos && (
                  <div className='col-12'>
                    <div className='ml-4'>
                      <h4>Tarjetas participantes</h4>

                      {TARJETAS.APINDIVIDUAL.map((tarjeta, index) => (
                        <img
                          {...tarjeta}
                          key={index}
                          alt={tarjeta.alt}
                          style={{ width: "200px" }}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='border p-4 position-relative h-100 d-flex'>
                <div className='w-100 align-self-center'>
                  <OpcionesPago
                    loading={isRecalculando}
                    datosTarifacion={datosTarifacion}
                    idCotizacion={idCotizacion}
                    correo={cotizacion?.carContratante?.usuCorreo ?? ""}
                    disablebtn={showOpciones && !seleccionMeses}
                    userIsLoggedIn={!!isAgente}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row justify-content-center my-5'>
            <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
              <button
                className='btn btn-atras-api'
                disabled={pagoRealizado}
                onClick={handleRegresar}>
                Atrás
              </button>
            </div>
            <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
              <button
                className='btn btn-siguiente-api'
                type='button'
                onClick={methods.handleSubmit(onSubmit, onSubmitError)}>
                Siguiente
              </button>
            </div>
          </div>
        </Page>
        <Dialog
          header='Asistencias'
          visible={state.dialogShow}
          style={{ width: "600px" }}
          onHide={() => setState({ dialogShow: false })}>
          {state.dialogData.map(({ descripcion }, i) => (
            <p key={`dialHoga${i}`} className='font-20px font-source-sans-regular'>
              {descripcion}
            </p>
          ))}
        </Dialog>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(HogarDatosGenerales);
